<template>
<div class="analytics-chart" :class="{collapsed}">
	<chart v-if="!collapsed" class="" :title="title" :data="values" :old-data="oldValues"
	       :prefix="prefix" :round-value="roundValue" :is-empty="isEmpty" :suffix="suffix"
	       :total="summary?summary.value:0" :old-total="summary?summary.old_value:0" :is-money="isMoney"
	       :startDate="startDate" :endDate="endDate" :loading="loading">
		<template v-slot:info>
			<slot name="info" />
		</template>
	</chart>


	<tippy v-else >
		<template v-slot:trigger>
			<div class="collapsed" >
				<div class="__title layout-row">
					<span class="">{{title}}</span>
					<info-icon v-if="$slots.info">
						<slot name="info"></slot>
					</info-icon>
					<div class="flex"></div>
					<div class="delta" :class="[deltaClass]">{{ Math.abs(delta) }}%</div>
				</div>
				<div class="__totals layout-row flex">
					<span class="total">{{valueFormatted}}</span>
					<div class="flex"></div>
					<!--			<span class="old-total">{{oldValueFormatted}}</span>-->
				</div>
				<v-spinner v-if="loading" />

			</div>
		</template>

			<span><u>{{title}}:</u> Was <b>{{oldValueFormatted}}</b>, now it's <b>{{valueFormatted}}</b></span>
	</tippy>
</div>
</template>

<script>
import Chart from "@/components/base/chart";
import API from "@/api";
import numbers from "@/helpers/numbers";
import InfoIcon from "@/components/base/info-icon";
import VSpinner from "@/components/base/v-spinner";

export default {
	name: "analytics-chart", components: {VSpinner, InfoIcon, Chart},
	props:['title', 'summary', 'startDate', 'endDate', 'prefix', 'suffix', 'isMoney',
	       'loading', 'values', 'oldValues', 'roundValue', 'collapsed', 'isEmpty'],
	mixins: [API],
	data() {
		return {
		}
	},
	methods: {
		formatValue(value) {
			let t = value || 0;
			let v = this.roundValue ? numbers.round_to_zero(t) : numbers.round_to_two(t);
			t = this.isMoney ? this.formatPrice(v) : v;
			return `${this.prefix} ${t}${this.suffix}`
		},
		formatPrice(value) {
			let val = (value/1).toFixed(2)//.replace('.', ',')
			return numbers.numberWithCommas(val)
		},
		fixPer(precentage) {
			let n = 0;
			n = numbers.round_to_two(precentage);

			if (isNaN(n))
				return 0;
			else
				return n;// Math.abs(n);
		},
	},
	computed:{
		valueFormatted() {
			return this.formatValue(this.value);
		},
		oldValueFormatted() {
			return this.formatValue(this.oldValue);
		},
		value(){
			return this.summary? this.summary.value:0
		},
		oldValue(){
			return this.summary? this.summary.old_value:0
		},
		// sign: function() {
		// 	return this.delta >= 0 ? "+" : "-";
		// },
		deltaClass: function() {
			return this.delta > 0 ? "delta-up" : this.delta < 0 ? "delta-down" : "delta-neutral";
		},
		delta: function () {
			let value = this.value || 0;
			let oldValue = this.oldValue || 0;
			let difference = (value-oldValue);

			if (!oldValue && value) return this.fixPer(100); // use current value as the change value.

			let per = difference/oldValue*100;

			return this.fixPer(per);
		}
	},
	created() {

	}
}
</script>

<style lang="scss" scoped>
.analytics-chart {
	display: flex;
	width: 100%;
	margin: 5px 0;

	&:nth-child(2) {
		margin-left: 10px;
	}
	&.collapsed {
		display: flex;
		flex-direction: column;
		border-radius: 4px;
		//border: 1px solid silver;
		padding: 20px 15px;
		margin: 0;
		background: #F6F9FE;
		width: 100%;
		position: relative;

		.__totals {
			margin-top: 10px;
			display: flex;
			flex-direction: row;
			align-items: center;
			.total, .old-total {
				font-size: 25px;
				font-weight: 600;
			}
		}
		.__title {
			display: flex;
			flex-direction: row;
			.delta {
				font-size: 14px;
				font-weight: 400;
				padding-right: 0;
			}

		}
	}
}
</style>
